var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_579_6456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.37793 14C2.4746 8.02667 7.70943 3.5 14.0001 3.5C20.2908 3.5 25.5244 8.02667 26.6223 14C25.5256 19.9733 20.2908 24.5 14.0001 24.5C7.70943 24.5 2.47576 19.9733 1.37793 14ZM14.0001 19.8333C15.5472 19.8333 17.0309 19.2188 18.1249 18.1248C19.2188 17.0308 19.8334 15.5471 19.8334 14C19.8334 12.4529 19.2188 10.9692 18.1249 9.87521C17.0309 8.78125 15.5472 8.16667 14.0001 8.16667C12.453 8.16667 10.9693 8.78125 9.87531 9.87521C8.78135 10.9692 8.16676 12.4529 8.16676 14C8.16676 15.5471 8.78135 17.0308 9.87531 18.1248C10.9693 19.2188 12.453 19.8333 14.0001 19.8333ZM14.0001 17.5C13.0718 17.5 12.1816 17.1313 11.5252 16.4749C10.8688 15.8185 10.5001 14.9283 10.5001 14C10.5001 13.0717 10.8688 12.1815 11.5252 11.5251C12.1816 10.8687 13.0718 10.5 14.0001 10.5C14.9284 10.5 15.8186 10.8687 16.475 11.5251C17.1313 12.1815 17.5001 13.0717 17.5001 14C17.5001 14.9283 17.1313 15.8185 16.475 16.4749C15.8186 17.1313 14.9284 17.5 14.0001 17.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_579_6456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.1f04e7c54971037a980210f5e270372e.svg";
export { ForwardRef as ReactComponent };